import styled from 'styled-components';
import { FlexColumn, StyledSvg as LibStyledSvg } from '@make-software/tg-mini-app-ui';

export const StyledButton = styled.button(({ theme }) =>
  theme.withMedia({
    color: theme.colors.cardBg,
    border: `1px solid ${theme.colors.border}`,
    background: theme.colors.successGreen,
    height: '36px',
    width: '90%',
    fontSize: '14px',
    fontWeight: '700',

    ':hover': {
      background: theme.colors.cardBg,
      color: theme.colors.lightGray,
      'svg path': {
        fill: theme.colors.contentPrimary
      }
    }
  })
);

export const StyledWalletColumn = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    marginTop: '16px'
  })
);

export const StyledSvg = styled(LibStyledSvg)(() => ({
  marginRight: '10px'
}));
